module.exports = __webpack_public_path__ + "static/img/pass_rule.74b6200.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pass_rule.png
// module id = TjQ2
// module chunks = 2